import { render } from "./caseView.vue?vue&type=template&id=060df91c&scoped=true"
import script from "./caseView.vue?vue&type=script&lang=js"
export * from "./caseView.vue?vue&type=script&lang=js"

import "./caseView.vue?vue&type=style&index=0&id=060df91c&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060df91c"]])

export default __exports__